import { createSlice } from '@reduxjs/toolkit';
import { clearReducers } from '../logout';

export const initialState = {
  items: [],
  loaded: true,
  pageable: {
    pageSize: 10,
    pageNumber: 0,
    totalElements: 0,
  },
  search: '',
  status: '',
  paquerId: '',
  type: '',
  date: {
    from: '',
    to: '',
  },
};

const packagesWithPaquersSlice = createSlice({
  name: 'packagesWithPaquers',
  initialState,
  reducers: {
    fetch: (state) => {
      state.loaded = false;
    },
    fetchSuccess: (state, action) => {
      state.items = action.payload.items;
      state.pageable.totalElements = action.payload.total;
      state.loaded = true;
    },
    fetchFailure: (state) => {
      state.loaded = true;
    },
    updatePageable: (state, action) => {
      state.pageable.pageNumber =
        action.payload.pageSize !== state.pageable.pageSize
          ? 0
          : action.payload.pageNumber;
      state.pageable.pageSize = action.payload.pageSize;
    },
    fetchOnePacket: (state) => {
      state.loaded = false;
    },
    fetchOnePacketSuccess: (state) => {
      state.loaded = true;
    },
    fetchOnePacketFailure: (state) => {
      state.loaded = true;
    },
    // Esto es porque PaquerSettingsButton puede (o no) modificar el estado del paquete. Se le delega la responsabilidad al sagas
    addPacket: () => {},
    updateSearch: (state, action) => {
      state.pageable.pageNumber = 0;
      state.search = action.payload;
    },
    updateStatus: (state, action) => {
      state.status = action.payload;
      state.pageable.pageNumber = 0;
    },
    updateDate: (state, action) => {
      state.date = action.payload;
      state.pageable.pageNumber = 0;
    },
    updatePaquerId: (state, action) => {
      state.paquerId = action.payload;
    },
    updatePackageType: (state, action) => {
      state.type = action.payload;
    },
    // Esto es porque components/paquerSelector utiliza este action en orden de editar el paquer y luego updatearlo con un PUT en paquerSettingsButton
    updatePackagePaquer: (state, action) => {
      const { packageId, selectedPaquer } = action.payload;
      const index = state.items.findIndex((item) => item.id === packageId);
      if (index > -1) {
        state.items[index].shippingScheduleDestination.driver = selectedPaquer;
      }
    },
    removePacket: (state, action) => {
      delete state.items[action.payload];
    },
    loading: (state) => {
      state.loaded = false;
    },
    loaded: (state) => {
      state.loaded = true;
    },
    resetFilters: (state) => {
      state.search = initialState.search;
      state.date = initialState.date;
      state.pageable = initialState.pageable;
    },
    clearItems: (state) => {
      state.items = initialState.items;
    },
    refreshPage: () => {},
  },
  extraReducers: {
    [clearReducers]: () => initialState,
  },
});

export const { name, actions, reducer } = packagesWithPaquersSlice;
